/**
 * Learn Mode — the launcher.
 *
 * This is the ONLY screen the feature owns. Everything a lesson teaches happens
 * on the real pages, with the tour overlay on top: this page just picks a lesson
 * and hands over. Progress lives under `cid.learn.progress`, its own localStorage
 * namespace, so a lesson can never disturb real state.
 */
import { useNavigate } from 'react-router-dom';
import AppBar from '../components/AppBar';
import { Chip, I } from '../components/kit';
import { LESSONS } from '../learn/tour';
import { readProgress, useTour } from '../learn/TourContext';

export default function LearnPage() {
  const nav = useNavigate();
  const tour = useTour();
  const progress = readProgress();

  return (
    <>
      <AppBar title="Learn the app" sub="Step-by-Step Guide to CIDAS" onBack={() => nav('/more')} />
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: 18, display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div style={{ background: 'var(--chip)', border: '1px solid color-mix(in srgb,var(--primary) 26%,var(--border))', borderRadius: 14, padding: '14px 16px' }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--primary)' }}>You drive, we point</div>
          <div style={{ fontSize: 11.5, color: 'var(--muted)', lineHeight: 1.5, marginTop: 5 }}>
            Each lesson walks you through the real screens and highlights the real buttons — you tap them yourself.
            The deal is pretend, and nothing reaches head office.
          </div>
        </div>

        {LESSONS.map((l) => {
          const p = progress[l.id] || {};
          const started = p.step > 0 && !p.done;
          return (
            <div
              key={l.id}
              role="button"
              tabIndex={0}
              className="tap"
              onClick={() => tour.start(l.id)}
              onKeyDown={(e) => e.key === 'Enter' && tour.start(l.id)}
              style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16, padding: 16, cursor: 'pointer' }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 600 }}>{l.name}</div>
                  <div style={{ fontSize: 11.5, color: 'var(--muted)', marginTop: 2 }}>{l.sub}</div>
                </div>
                {p.done ? <Chip label="Done" tone="ok" /> : started ? <Chip label={`Step ${p.step + 1}`} tone="warn" /> : <Chip label={`${l.mins} min`} tone="muted" />}
                <I.chevR style={{ color: 'var(--muted)', flex: 'none' }} />
              </div>
              <div style={{ fontSize: 12.5, color: 'var(--muted)', lineHeight: 1.55, marginTop: 10 }}>{l.blurb}</div>
              {p.done && (
                <button
                  type="button"
                  onClick={(e) => { e.stopPropagation(); tour.start(l.id, { restart: true }); }}
                  style={{ marginTop: 12, background: 'var(--surface2)', border: '1px solid var(--border)', color: 'var(--muted)', borderRadius: 10, padding: '8px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
                >
                  Run it again
                </button>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}
